import { injectable } from 'inversify';
import { observable } from 'mobx';

import type { JourneyRouteParams } from '~types/navigation';

@injectable()
export class JourneysStore {
  @observable isFetching = false;

  @observable journeyParams?: JourneyRouteParams = undefined;
}
